/**
 * <s-filter-scope> — enables its <fieldset> only while a media query matches.
 *
 * Collection filters render twice (desktop sidebar + mobile drawer) inside one
 * form. A disabled fieldset is left out of FormData, so only the copy that is
 * visible at the current screen width is submitted.
 *
 * Required markup:
 *   <s-filter-scope media="(min-width: 1024px)"><fieldset>…</fieldset></s-filter-scope>
 */
class SFilterScope extends HTMLElement {
  #mql;
  #ac;

  connectedCallback() {
    const query = this.getAttribute('media');
    if (!query) return;
    this.#ac = new AbortController();
    this.#mql = window.matchMedia(query);
    this.#mql.addEventListener('change', this.#sync, { signal: this.#ac.signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync = () => {
    const fieldset = this.querySelector('fieldset');
    if (fieldset) fieldset.disabled = !this.#mql?.matches;
  };
}

if (!customElements.get('s-filter-scope')) {
  customElements.define('s-filter-scope', SFilterScope);
}
